import Recordset from '@/providers/api/Recordset'

const images = {
  methods: {
    //needs values: "imageKeys", "item"
    applyImages (resource, id, item = false) {
      if (!this.imageKeys || !this.imageKeys.length ) {
        return Promise.resolve();
      }
      var removals = [];
      var additions = [];
      for (let key of this.imageKeys) {
        let attachment_type = key === 'image' ? 'main' : key;
        let newValues = this.item[key];
        if (newValues && typeof newValues === 'object' && !Array.isArray(newValues)) {
          newValues = newValues.list.map(v => v.id);
        }
        if (typeof newValues === 'number') {
          newValues = [newValues];
        }
        if (!newValues) {
          newValues = [];
        }
        if (item === false) {
          item = this.model;
        }
        let currentValues = (item.images || new Recordset('images'))
          .filter(i => !i.pivot || !i.pivot.attachment_type || (i.pivot.attachment_type === attachment_type))
          .list
          .map(i => i.id)
        ;
        //DETACH
        removals = removals.concat(
          //find all current values that are not present in new values
          currentValues.filter(v => !newValues.includes(v))
            //prepare a delete request for every value
            .map(image_id =>
              this.api.delete('images/' + image_id + '/' + resource + '/' + id)
            )
        );
        //ATTACH
        additions = additions.concat(
          //find all new values that are not present in current values
          newValues.filter(v => !currentValues.includes(v))
            //prepare a post request for every value
            .map(image_id =>
              this.api.post('images/' + image_id + '/' + resource + '/' + id, {
                attachment_type
              })
            )
        );
      }
      return Promise.all(removals).then(() => Promise.all(additions));
    },
    //needs values: "tagsKeys", "item"
    applyTags (resource, id, item = false) {
      if (!this.tagsKeys || !this.tagsKeys.length ) {
        return Promise.resolve();
      }
      var removals = [];
      var additions = [];
      for (let key of this.tagsKeys) {
        let newValues = this.item[key];
        if (!Array.isArray(newValues)) {
          console.log('Tags should be an array', newValues);
          newValues = [];
        }
        if (item === false) {
          item = this.model;
        }
        let oldLowercase = (item.tags || new Recordset('tags'))
          .list
          .map(i => i.name.toLowerCase())
        ;
        for (let current of (item.tags || new Recordset('tags'))) {
          if (newValues.map(v => v.toLowerCase()).indexOf(current.name.toLowerCase()) === -1) {
            //DETACH
            removals.push(
              this.api.delete('tags/' + current.id + '/' + resource + '/' + id)
            );
          }
        }
        for (let newName of newValues) {
          newName = newName.trim();
          if (oldLowercase.indexOf(newName.toLowerCase()) !== -1) {
            continue;
          }
          additions.push(
            this.api
              //search for existing tag ID
              .get('tags?filter=name::eq::' + encodeURIComponent(newName) + '&range=single')
              .then(tag => {
                if (tag.length) {
                  //return tag ID if the tag exists
                  return tag.id;
                } else {
                  //create new tag otherwise and return its ID
                  return this.api
                    .post('tags', {
                      name: newName,
                    })
                    .then(response => response.resource_id)
                  ;
                }
              })
              //tag ID should be passed to here - attach it to resource
              .then(tag_id =>
                this.api.post('tags/' + tag_id + '/' + resource + '/' + id)
              )
          );
        }
      }
      return Promise.all(removals).then(() => Promise.all(additions));
    },
  },
};

export default images;


// WEBPACK FOOTER //
// ./src/helpers/mixins/form/images.js